import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useCallback,
  useImperativeHandle,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import { getInitFormData } from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/Grid/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_PMS_BAS_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const { userInfo } = global(); // Login user 정보
  const gridApiRef1 = useRef<any>(null); // 첫 번째  그리드 Reference 변수
  const searchRef = useRef<any>(null);
  const [focusedRowData, setFocusedRowData] = useState<any>();
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns1, setColums1] = useState<any[]>([]); // gridApiRef1 컬럼 설정 관련
  const [dataSource1, setDataSource1] = useState<any[]>([]); // gridApiRef1 datasource 관련
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      setDataSource1([]);
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        setColums1(rtn.grid.grid1);
      } catch (error) {}
    };
    fetchform();
  }, []);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  //#region Search
  const onSearch = async () => {
    const modifiedRows1 = gridApiRef1.current.getChange();
    if (modifiedRows1.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      const params = {
        id: "sn_pms_bas_reg_001_01",
        params: searchRef.current.getFormdata(),
      };
      setFocusedRowData(0);

      setDataSource1([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));
        gridApiRef1.current.selectAndFocusRow(0);
      }
      gridApiRef1.current.resetUpdate();
    } catch (error: any) {}
  };

  //#region BeforeaddRow
  const onBeforeAddRowH = (newRow: RowData): boolean => {
    try {
      const updatedRow = {
        cd_firm: userInfo?.cd_firm,
        cd_cb: "",
        nm_cb: "",
        fg_pjt: "",
        yn_use: "Y",
        cd_user_reg: userInfo?.cd_user,
      };
      Object.assign(newRow, updatedRow); // 원본 객체 수정
      return true;
    } catch (error: any) {
      return false;
    }
  };

  //#region On Insert
  const onInsert = async () => {
    const newRow = {}; // 빈 객체
    gridApiRef1.current?.addRow(newRow);
    setTimeout(() => {
      gridApiRef1.current.api.setFocusedCell(
        gridApiRef1.current.api.getDisplayedRowCount() - 1,
        "cd_cb"
      );
    }, 50);
  };

  //#region On Delete
  const onDelete = async () => {
    try {
      gridApiRef1.current.deleteSelectedRows();
    } catch (error) {}
  };

  //#region on Save
  const onSave = async () => {
    try {
      let SaveData: any = {};
      gridApiRef1.current.api.stopEditing();

      const requiredValuesCheck = gridApiRef1.current.requiredValuesCheck();
      if (!requiredValuesCheck) {
        return;
      }

      const gridGetChanges = gridApiRef1.current.getChange();
      if (gridGetChanges.modifiedRowcount == 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      SaveData["pms_cb"] = gridGetChanges;
      await fnSave("SN_PMS_BAS_REG_001_SAVE_01", SaveData);
      gridApiRef1.current.resetUpdate();

      SaveData = [];
    } catch (error: any) {}
  };
  //#endregion

  //#region  Event Method
  const onFocusedRowChanged = useCallback(
    (focusedRowData: any | null) => {
      setFocusedRowData(focusedRowData);
    },
    [focusedRowData]
  );

  //#region CellValueChanged
  const onCellValueChanged = async (event: any) => {
    if (!event) return;

    if (event.data.state === undefined) {
      event.data.cd_user_amd = userInfo.cd_user;
    }
  };
  //#endregion

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        />
      </div>
      <SnGrid
        
        seq={1}
        ref={gridApiRef1}
        columnConfig={columns1}
        rowData={dataSource1}
        isEditable={true}
        rowSelection="single"
        onCellValueChanged={onCellValueChanged}
        onFocusedRowChanged={onFocusedRowChanged}
        onBeforeAddRow={onBeforeAddRowH}
      />
    </div>
  );
  //#endregion
});
export default SN_PMS_BAS_REG_001;
